const LayoutDefault = () => import('@/layout/Default');

const OrderStudentExam = () => import('@/views/OrderStudentExam/Index');

export default {
  path: '/simulados',
  component: LayoutDefault,
  children: [
    {
      path: 'ordenar',
      name: 'OrderStudentExam',
      component: OrderStudentExam,
    },
  ],
};
